/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { C3ClusterTag } from '@camunda/camunda-composite-components';
import { FormLabel } from '@carbon/react';
import styled from 'styled-components';

export default function SelectedCluster({ selectedStage, selectedCluster }) {
  return (
    <Container>
      <FormLabel>Your process application will be deployed to</FormLabel>
      <Content>
        <C3ClusterTag stage={selectedStage} />{' '}
        <ClusterName>{`${selectedCluster.name} ${selectedCluster?.version ? `(${selectedCluster.version})` : ''}`}</ClusterName>
      </Content>
    </Container>
  );
}

const Container = styled.div``;

const Content = styled.div`
  height: 40px;
  align-content: center;
`;

const ClusterName = styled.span`
  vertical-align: middle;
`;
